import styled from 'styled-components';

export const StyledThreeElementRow = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 4px;

    @media only screen and (max-width: 600px) {
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 18px;
    }

    @media only screen and (max-width: 519px) {
        margin-bottom: 6px;
    }
`;
